export enum VrlCategory {
    Serology = 0,
    AntibodyScreening = 1
}